import React, { FC } from "react";
import styles from "./SuccessModel.module.scss";

interface IProps {
  onClick: any;
  balanceAmount: any;
  paymentType: String;
  customerName?: String;
}

const SuccessModel: FC<IProps> = ({
  balanceAmount,
  onClick,
  paymentType,
  customerName,
}) => {
  console.log(balanceAmount);
  return (
    <div className={styles.overlay_model}>
      <div className={styles.success_model}>
        <div className={styles.success_model_container}>
          <h3>Sales completed</h3>
          {paymentType === "cash" ? (
            <div>
              <span>Balance Amount: </span>
              <span>{balanceAmount}</span>
            </div>
          ) : (
            <div>
              <p>
                Credit purchase has been approved to {customerName}'s account{" "}
              </p>
            </div>
          )}

          <button onClick={onClick}>Start new sale</button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModel;
